








import { Component, Vue } from "vue-property-decorator";
import FormularioTrekking from "@/components/Formularios/FormularioTrekking.vue";

@Component({
  components: {
    FormularioTrekking
  },
  meta: {
    // sets document title
    title: "Postulación Trekking - Ilustre Municipalidad de Punta Arenas",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Ilustre Municipalidad de Punta Arenas"
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class NavidadView extends Vue {
  private mounted() {
    document.title =
      "Postulación Trekking - Ilustre Municipalidad de Punta Arenas";
  }
}
